import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Mumbaicarrenatlservice() {



    const cardData = {




keyword: "Mumbai Car Rental Service",

headingDescription: "Shreesha Tours & Travels provides reliable and affordable Mumbai Car Rental Services for local travel, outstation trips, corporate transportation, airport transfers, sightseeing tours, weddings, events, and long-distance journeys. We offer chauffeur-driven car rental solutions with flexible hourly, daily, weekly, and monthly rental packages to meet the requirements of families, business travelers, tourists, corporate companies, and individuals. Our fleet includes Sedan, Swift Dzire, Ertiga, SUV, Innova, Innova Crysta, Toyota Hycross, Tempo Traveller, Urbania, Mini Bus, and luxury vehicles suitable for every travel need and group size. With professional drivers, well-maintained cars, transparent pricing, doorstep pickup, flexible booking options, and 24/7 customer support, Shreesha Tours & Travels ensures a comfortable and hassle-free travel experience. Whether you need a rental car for business meetings, airport pickup and drop, wedding transportation, family vacations, corporate events, pilgrimage tours, or outstation travel from Mumbai to other cities, our car rental service provides safe, punctual, and premium transportation solutions.",

topPlaces: [
  {
    title: "Mumbai to Pune",
    description: "Pune is one of the most preferred destinations for Mumbai car rental services, offering business travel, IT park visits, educational trips, and family transportation. Popular areas include Hinjawadi, Kharadi, Magarpatta, Baner, and Koregaon Park."
  },
  {
    title: "Mumbai to Lonavala",
    description: "Lonavala is a popular hill station near Mumbai known for waterfalls, valleys, forts, lakes, and scenic viewpoints. Car rental services are commonly booked for weekend trips, family outings, couples' vacations, and corporate getaways."
  },
  {
    title: "Mumbai to Mahabaleshwar",
    description: "Mahabaleshwar is famous for strawberry farms, Venna Lake, viewpoints, waterfalls, and cool weather. Travelers prefer rental cars for comfortable hill station journeys with flexible sightseeing options."
  },
  {
    title: "Mumbai to Goa",
    description: "Goa is a popular long-distance travel destination known for beaches, resorts, churches, forts, and nightlife. Rental cars from Mumbai provide convenient transportation for family holidays, group tours, and vacation trips."
  },
  {
    title: "Mumbai to Shirdi",
    description: "Shirdi is one of India's most visited pilgrimage destinations, attracting devotees visiting Sai Baba Temple. Car rental services provide comfortable travel options for families, senior citizens, and religious groups."
  },
  {
    title: "Mumbai to Nashik",
    description: "Nashik is known for Trimbakeshwar Jyotirlinga, vineyards, industrial areas, and scenic attractions. Car rentals are preferred for religious tours, corporate visits, and weekend travel."
  },
  {
    title: "Mumbai to Alibaug",
    description: "Alibaug is a beautiful coastal destination near Mumbai, famous for beaches, forts, resorts, and peaceful surroundings. It is a popular choice for weekend holidays, destination events, and family trips."
  },
  {
    title: "Mumbai to Surat",
    description: "Surat is a major commercial city known for diamond and textile industries. Car rental services are widely used by business travelers, traders, and corporate professionals traveling between Mumbai and Surat."
  },
  {
    title: "Mumbai to Ahmedabad",
    description: "Ahmedabad is Gujarat's business and cultural hub with industries, corporate offices, and heritage attractions. Rental cars provide comfortable transportation for business meetings, family visits, and tourism."
  },
  {
    title: "Mumbai to Indore",
    description: "Indore is a growing business destination in Madhya Pradesh, known for industries, commercial centers, food markets, and nearby religious places like Ujjain and Omkareshwar. Long-distance car rental services offer convenient travel solutions from Mumbai."
  }
],



"services": [
  {
    "name": "Mumbai Car Rental Service",
    "description": "Book Mumbai Car Rental Service for comfortable and reliable transportation with chauffeur-driven vehicles for local travel, airport transfers, corporate trips, sightseeing, weddings, and outstation journeys. Choose from Sedan, Ertiga, Innova Crysta, SUV, luxury cars, and Tempo Traveller options with flexible rental packages and professional drivers."
  },
  {
    "name": "Car Rental Mumbai",
    "description": "Choose Car Rental Mumbai for affordable and convenient vehicle rental solutions with well-maintained cars and flexible booking options. Get comfortable transportation for business meetings, family trips, city travel, airport pickup and drop, and long-distance travel with reliable service."
  },
  {
    "name": "Mumbai Car Hire Service",
    "description": "Hire Mumbai Car Hire Service for private chauffeur-driven vehicles with experienced drivers and premium travel comfort. Select from multiple car categories including Sedan, SUV, Innova Crysta, and luxury vehicles for personal, corporate, and tourist transportation requirements."
  },
  {
    "name": "Mumbai Self Drive Car Rental",
    "description": "Book Mumbai Self Drive Car Rental for flexible travel freedom with well-maintained vehicles available for personal trips, weekend getaways, business travel, and local exploration. Enjoy convenient car rental options with easy booking and comfortable vehicles."
  },
  {
    "name": "Mumbai Car Rental with Driver",
    "description": "Choose Mumbai Car Rental with Driver for stress-free travel with professional chauffeurs and comfortable AC cars. Ideal for airport transfers, corporate travel, family vacations, sightseeing tours, weddings, and outstation journeys with safe and reliable transportation."
  },
  {
    "name": "Mumbai Chauffeur Car Rental",
    "description": "Book Mumbai Chauffeur Car Rental for premium travel experiences with trained chauffeurs and luxury vehicles. Enjoy punctual service, comfortable interiors, and professional transportation for business meetings, VIP travel, events, and special occasions."
  },
  {
    "name": "Mumbai Luxury Car Rental",
    "description": "Hire Mumbai Luxury Car Rental services for premium vehicles including Mercedes, BMW, Audi, Jaguar, and luxury SUVs. Perfect for weddings, corporate events, VIP transportation, airport transfers, celebrations, and special occasions requiring stylish and comfortable travel."
  },
  {
    "name": "Mumbai Outstation Car Rental",
    "description": "Reserve Mumbai Outstation Car Rental for safe and comfortable long-distance journeys with professional drivers and premium vehicles. Travel from Mumbai to destinations across Maharashtra, Goa, Gujarat, Karnataka, and other states with flexible one way and round trip rental packages."
  },
  {
    "name": "Mumbai Airport Car Rental",
    "description": "Book Mumbai Airport Car Rental for convenient airport pickup and drop services with clean AC vehicles and professional chauffeurs. Enjoy timely transfers from Mumbai Airport to hotels, offices, residential areas, and outstation destinations with reliable transportation."
  },
  {
    "name": "Mumbai Monthly Car Rental",
    "description": "Choose Mumbai Monthly Car Rental for long-term vehicle rental solutions with chauffeur-driven cars, dedicated drivers, and cost-effective packages. Ideal for corporate requirements, employee transportation, business executives, and regular travel needs with flexible monthly plans."
  },
  {
    "name": "Mumbai Corporate Car Rental",
    "description": "Hire Mumbai Corporate Car Rental for professional business transportation including executive travel, employee movement, client meetings, airport transfers, and corporate events. Get premium vehicles, trained chauffeurs, customized packages, and reliable service for companies."
  },
  {
    "name": "Mumbai Tourist Car Rental",
    "description": "Book Mumbai Tourist Car Rental for comfortable sightseeing and holiday travel with experienced drivers and spacious vehicles. Explore Mumbai attractions, nearby hill stations, beaches, temples, and tourist destinations with customized travel packages."
  },
  {
    "name": "Affordable Car Rental Mumbai",
    "description": "Choose Affordable Car Rental Mumbai for budget-friendly transportation without compromising comfort and safety. Enjoy clean vehicles, professional drivers, transparent pricing, and flexible rental options for local travel, airport transfers, family trips, and outstation journeys."
  }
],
"tableData": [
  ["Mumbai Car Rental Service", "Car Rental Mumbai"],
  ["Mumbai Car Hire Service", "Mumbai Self Drive Car Rental"],
  ["Mumbai Car Rental with Driver", "Mumbai Chauffeur Car Rental"],
  ["Mumbai Luxury Car Rental", "Mumbai Outstation Car Rental"],
  ["Mumbai Airport Car Rental", "Mumbai Monthly Car Rental"],
  ["Mumbai Corporate Car Rental", "Mumbai Tourist Car Rental"],
  ["Affordable Car Rental Mumbai", ""]
],




whychoose: [
  {
    WhyChooseheading: "Premium Mumbai Car Rental Service for Every Occasion",
    WhyChoosedescription: "Shreesha Tours & Travels provides reliable car rental services in Mumbai for local travel, business meetings, airport transfers, weddings, sightseeing, corporate events, and outstation journeys with comfortable vehicles and professional drivers."
  },
  {
    WhyChooseheading: "Flexible Car Rental Options in Mumbai",
    WhyChoosedescription: "Choose hourly rentals, full-day car rentals, daily packages, outstation rentals, one-way travel, round trips, and customized rental plans based on your schedule and travel requirements."
  },
  {
    WhyChooseheading: "Wide Range of Cars Available",
    WhyChoosedescription: "Select from Hatchbacks, Swift Dzire, Sedan, Ertiga, Innova, Innova Crysta, SUVs, Luxury Cars, Tempo Travellers, and premium vehicles suitable for individuals, families, and groups."
  },
  {
    WhyChooseheading: "Ideal for Corporate & Business Travel",
    WhyChoosedescription: "Our Mumbai car rental service supports executives, companies, and business travellers with professional vehicles for meetings, conferences, office travel, and client transportation."
  },
  {
    WhyChooseheading: "Airport & Hotel Car Rental Solutions",
    WhyChoosedescription: "Enjoy convenient pickup and drop services from Mumbai Airport, railway stations, hotels, offices, and residential locations with timely vehicle availability."
  },
  {
    WhyChooseheading: "Professional Drivers with Local Expertise",
    WhyChoosedescription: "Our experienced chauffeurs understand Mumbai routes, traffic conditions, and important destinations, ensuring a comfortable and efficient travel experience."
  },
  {
    WhyChooseheading: "Clean & Well-Maintained Rental Vehicles",
    WhyChoosedescription: "Every vehicle is regularly serviced, sanitized, air-conditioned, and maintained with comfortable interiors to provide a pleasant journey."
  },
  {
    WhyChooseheading: "Trusted Car Rental Partner in Mumbai",
    WhyChoosedescription: "With transparent pricing, quick booking assistance, and customer-focused service, Shreesha Tours & Travels offers dependable car rental solutions for all travel needs."
  }
]

};

const faqData = [
  {
    question: "What types of cars are available for rental in Mumbai?",
    answer: "You can rent Hatchbacks, Swift Dzire, Sedan, Ertiga, Innova, Innova Crysta, SUVs, Luxury Cars, Tempo Travellers, and other premium vehicles."
  },
  {
    question: "Can I rent a car with a driver in Mumbai?",
    answer: "Yes, chauffeur-driven car rental services are available for local travel, business trips, airport transfers, and outstation journeys."
  },
  {
    question: "Is hourly car rental available in Mumbai?",
    answer: "Yes, hourly rentals, half-day packages, full-day rentals, and customized travel plans are available."
  },
  {
    question: "Can I rent a car for corporate meetings and events?",
    answer: "Yes, our rental cars are suitable for corporate meetings, conferences, employee travel, and client transportation."
  },
  {
    question: "Do you provide airport car rental services?",
    answer: "Yes, we offer Mumbai Airport pickup and drop car rental services for passengers, executives, and guests."
  },
  {
    question: "Can I book a rental car for outstation travel from Mumbai?",
    answer: "Yes, car rental services are available for one-way trips, round trips, and long-distance travel to destinations across India."
  },
  {
    question: "Are luxury cars available for special occasions?",
    answer: "Yes, premium and luxury vehicles can be arranged for weddings, VIP travel, corporate events, and special occasions."
  },
  {
    question: "Can large groups rent vehicles in Mumbai?",
    answer: "Yes, Tempo Travellers and larger vehicles are available for family tours, corporate outings, group travel, and events."
  },
  {
    question: "How is the Mumbai car rental price calculated?",
    answer: "The rental cost depends on the selected vehicle, rental duration, travel distance, trip type, and additional requirements."
  },
  {
    question: "How can I book a Mumbai Car Rental Service with Shreesha Tours & Travels?",
    answer: "Share your travel date, pickup location, destination, rental duration, passenger count, and preferred vehicle to receive a customized quotation and booking confirmation."
  }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Vikram Joshi",
    feedback: "I rented an Innova Crysta from Shreesha Tours & Travels for a business trip in Mumbai. The vehicle was clean, comfortable, and the driver provided excellent service throughout the journey.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Anjali Mehta",
    feedback: "We hired a car for a family sightseeing tour in Mumbai. The booking was easy, the car was spacious, and the driver helped us complete the trip comfortably.",
    rating: 5
  }
];















    const Images = [
        { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cabs" },
        { place: "/images/keyword/2.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
        { place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
        { place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
        { place: "/images/keyword/5.jpg", text: "Mumbai to Nashik Cab", link: "Mumbai-to-Nashik-Cab" },
        { place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
        { place: "/images/keyword/7.jpg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
        { place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
        { place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
        { place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
        { place: "/images/keyword/11.jpg", text: "Mumbai to 5 Jyotirlinga Cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
        { place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
        { place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
        { place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
        { place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
        { place: "/images/keyword/16.jpg", text: "Mumbai to Matheran Cab", link: "Mumbai-to-Matheran-Cab" },
        { place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Cab-Booking-Dhule" },
        { place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
        { place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
        { place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
        { place: "/images/keyword/21.jpg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
        { place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
        { place: "/images/keyword/23.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "Mumbai-to-Narmada-Parikrama-Cab-Booking" },
        { place: "/images/keyword/24.jpg", text: "Mumbai to Baroda Cabs", link: "Mumbai-to-Baroda-Cabs" },
        { place: "/images/keyword/25.jpg", text: "Mumbai to Daman Taxi", link: "Mumbai-to-Daman-Taxi" },
    ];








const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai Car Rental Service",
  "image": "https://www.shreeshatravels.com/assets/images/mumbai-car-rental-service.webp",
  "description":
    "Book Mumbai Car Rental Service with Shreesha Tours & Travels for safe, comfortable, and affordable chauffeur-driven car rental solutions. We offer Sedan, Ertiga, SUV, Innova, and Innova Crysta available 24x7 for local travel, airport transfers, corporate travel, weddings, sightseeing tours, family trips, and outstation journeys across Maharashtra and India.",
  "brand": {
    "@type": "Brand",
    "name": "Shreesha Tours & Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8517"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://www.shreeshatravels.com/mumbai-car-rental-service"
  }
};




    return (
        <div>

<Helmet>
  <title>Mumbai Car Rental Service | Chauffeur Driven Cars | +91 8355835813</title>

  <meta
    name="description"
    content="Book Mumbai Car Rental Service with Shreesha Travels for reliable chauffeur-driven cars for local, airport, corporate, wedding, sightseeing, and outstation travel. Choose Sedan, Ertiga, SUV, Innova, and Innova Crysta with 24x7 booking."
  />

  <meta
    name="keywords"
    content="Mumbai Car Rental Service, Car Rental Mumbai, Mumbai Car Hire Service, Mumbai Self Drive Car Rental, Mumbai Car Rental with Driver, Mumbai Chauffeur Car Rental, Mumbai Car Booking, Mumbai Car Hire, Mumbai Airport Car Rental, Mumbai Outstation Car Rental, Luxury Car Rental Mumbai, Affordable Car Rental Mumbai"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>



            <section className="page-banner">
                <div className="page-banner-container">
                    <h2>
                        {cardData.keyword}
                    </h2>
                </div>
            </section>


















            <section>
                <div className="container-fluid p-0" >
                    <div className="row container-fluid px-md-2">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/40.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Shreesha Tours & Travels: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>

                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>





                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div className="service-card" key={index}>
                                        <div className="service-content">
                                            <h4>{service.name}</h4>
                                            <span className="line"></span>
                                            <p>{service.description}</p>
                                        </div>

                                        <div className="service-icon">
                                            <i className="fas fa-arrow-right"></i>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            <div className="keyword-grid">
                                {cardData.tableData.flat().map((keyword, index) => (
                                    <div key={index} className="keyword-item">
                                        <span className="keyword-bullet">-</span>
                                        {keyword}
                                    </div>
                                ))}
                            </div>



                            <div id="why-choose-section" className="why-choose-section">

                                <h2 className="section-title text-dark">
                                    Why Choose <span>Shreesha Tours & Travels</span>
                                </h2>

                                <div className="bento-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div className="bento-card" key={index}>

                                            <div className="bento-number">
                                                {String(index + 1).padStart(2, "0")}
                                            </div>

                                            <h4>{item.WhyChooseheading}</h4>

                                            <p>{item.WhyChoosedescription}</p>

                                        </div>
                                    ))}
                                </div>

                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Shreesha Tours & Travels </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title=""
                                                    subtitle=""
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fas fa-phone-alt"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+918355835813 " className="pc-call">+91 8355835813 </a>
                                        </div>
                                        <div className="pc-list">
                                            <a href="tel:+919930929439 " className="pc-call">+91 9930929439 </a>
                                        </div>
                                        <div className="pc-list">
                                            <a href="tel:+919022432779 " className="pc-call">+91 9022432779 </a>
                                        </div>
                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/91919930929439 "
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+918355835813 " className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-envelope"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@shreeshatravels.com" className="pc-email">
                                            booking@shreeshatravels.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-location-dot"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Shreesha Tours & Travels</strong><br />
                                            Office 125, Saishraddha CHS,
                                            Plot No 47, Near Koparkhairane Police Station,
                                            Sector 5, Sector 4,Ghansoli, Navi Mumbai,
                                            Maharashtra, India- 400701




                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Mumbaicarrenatlservice